export const SESSION_IDLE_TIMEOUT_MS = 30 * 60 * 1000;
export const SESSION_WARNING_MS = 5 * 60 * 1000;

const activityStorageKey = "piers.session-activity";
let lastUserActivity = Date.now();
let activityPending = false;
let lastActivityBroadcast = 0;
let lastActivitySignal = 0;

export const recordUserActivity = ({ broadcast = true } = {}) => {
  const now = Date.now();
  lastUserActivity = now;
  activityPending = true;

  if (broadcast && now - lastActivityBroadcast >= 5000) {
    lastActivityBroadcast = now;
    try {
      localStorage.setItem(activityStorageKey, String(now));
    } catch {
      /* Storage is optional. */
    }
  }
};

export const getLastUserActivity = () => lastUserActivity;
export const hasPendingUserActivity = () => activityPending;

export const consumeUserActivitySignal = () => {
  const now = Date.now();
  if (
    !activityPending ||
    now - lastUserActivity >= SESSION_IDLE_TIMEOUT_MS ||
    now - lastActivitySignal < 60000
  )
    return false;
  activityPending = false;
  lastActivitySignal = now;
  return true;
};

export const subscribeToUserActivity = (onActivity) => {
  const record = () => {
    recordUserActivity();
    onActivity?.();
  };

  const onStorage = (event) => {
    if (event.key !== activityStorageKey || !event.newValue) return;
    const timestamp = Number(event.newValue);
    if (!Number.isFinite(timestamp) || timestamp <= lastUserActivity) return;
    lastUserActivity = timestamp;
    activityPending = true;
    onActivity?.();
  };

  window.addEventListener("pointerdown", record, true);
  window.addEventListener("keydown", record, true);
  window.addEventListener("touchstart", record, {
    capture: true,
    passive: true,
  });
  window.addEventListener("wheel", record, { capture: true, passive: true });
  window.addEventListener("storage", onStorage);

  return () => {
    window.removeEventListener("pointerdown", record, true);
    window.removeEventListener("keydown", record, true);
    window.removeEventListener("touchstart", record, true);
    window.removeEventListener("wheel", record, true);
    window.removeEventListener("storage", onStorage);
  };
};
